<template>
    <a :class="['parametric-card', {'is-booked': flat.isBooked}]" :href="flat.link">
        <div class="parametric-card__content">
            <div class="parametric-card__params">
                <h2 class="parametric-card__title parametric-results__loader">
                    {{ flat.title }}
                    <div v-if="!isEstateFlat && flat.building && flat.section" class="parametric-results__annotation">
                        Корпус {{ flat.building }}, секция {{ flat.section }}
                    </div>
                </h2>

                <ul v-if="flat.options" class="tags tags_theme_not-order">
                    <li
                        v-for="option in flat.options"
                        :key="option.key"
                        :class="['tags__item', `tags__item_color_${option.color}`,
                        'tags__item_theme_flat', 'tags__item_theme_narrow', 'parametric-results__loader']"
                    >
                        {{ option.name }}
                    </li>
                </ul>

                <ul class="parametric-card__params-list">
                    <li class="parametric-card__params-list-item parametric-results__loader">
                        <span>{{ flat.area }} м<sup>2</sup></span>
                    </li>

                    <li v-if="isEstateFlat" class="parametric-card__params-list-item parametric-results__loader">
                        <span>{{ flat.floor }}/{{ flat.floorsTotal }} этаж</span>
                    </li>

                    <li class="parametric-card__params-list-item parametric-results__loader">
                        <span>{{ flat.deadlineText }}</span>
                    </li>
                </ul>

                <div v-if="flat.isBooked" class="parametric-card__state parametric-results__loader">Забронировано</div>

                <div v-if="!flat.isBooked" class="parametric-card__prices">
                    <div class="parametric-results__loader">{{ convertToDigit(flat.price) }} руб</div>

                    <div v-if="flat.priceOld" class="parametric-card__price-old parametric-results__loader">
                        {{ convertToDigit(flat.priceOld) }} руб
                    </div>
                </div>
            </div>

            <div class="parametric-card__plan">
                <div class="parametric-results__loader">
                    <img :src="flat.plan" :alt="flat.title">
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import {convertToDigit} from '../../mixins.js';
import {mapGetters} from 'vuex';

export default {
    props   : ['flat'],
    computed: {
        ...mapGetters({
            estateType: 'GET_ESTATETYPE'
        }),

        isEstateFlat() {
            return this.estateType === 1;
        }
    },
    mixins: [convertToDigit]
};
</script>
